// extracted by mini-css-extract-plugin
export default {"section":"styles-module__section__src-labstep-web-components-Experiment-CompletionChecklist-Content-_u7CdM"};